const PreviewableImage = {
    name: 'PreviewableImage',
    data() {
        return {
            dataUrl: '',
        }
    },
    methods: {
        loadPreview(e) {
            e.preventDefault()
            let image = e.target;
            let _this = this;
            image.dataset

            if (image.files instanceof FileList || image.files instanceof File) {
                var reader = new FileReader();

                reader.addEventListener('load', function (e) {
                    // this.img.setAttribute('src', e.target.result);
                    _this.dataUrl = e.target.result;
                })

                reader.readAsDataURL(e.target.files[0]); // convert to base64 string
            }
        }
    },
    props: {
        target: {
            type: String,
            default: null,
        },
    },

    mounted() {
        if (this.target != null) {
            this.img = this.$el.querySelector(`${this.target}_preview`);
            this.input = this.$el.querySelector(this.target);

        } else {
            this.img = this.$el.querySelector('img');
            this.input = this.$el.querySelector('input');
        }

        this.input.addEventListener('change', this.loadPreview)
    },
    render() {

        return this.$scopedSlots.default({
            dataUrl: this.dataUrl
        });
    }
}

export default PreviewableImage;
